import { cva } from '@/styled-system/css';

export const containerRecipe = cva({
  base: {
    textAlign: 'center',
    alignItems: 'center',
    border: '1px solid {colors.border.subtle}',
    borderRadius: 'obj.default',
    color: 'text.neutral',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    padding: '200',
    transition: 'border 0.24s ease-in-out',
  },
  variants: {
    isContainerSizeFixed: {
      true: {
        height: '100px',
        width: '100px',
      },
      false: {
        height: '100%',
        width: '100%',
      },
    },
    isSmallDropzone: {
      true: {
        md: {
          minHeight: '90px',
        },
      },
      false: {
        md: {
          minHeight: '240px',
        },
      },
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 'disabled',
        backgroundColor: 'bg.softer',
      },
      false: {
        cursor: 'pointer',
        opacity: 'action.active',
      },
    },
    isDragAccept: {
      true: {
        border: '2px solid {colors.border.accent.brand.hero}',
        backgroundColor: 'bg.softer',
      },
      false: {},
    },
    isDragReject: {
      true: {
        border: '1px solid {colors.border.accent.red.hero}',
      },
      false: {},
    },
  },
});
